<template>
  <div>
    <input
      class="orm-input__control orm-km-input"
      id="kmDistance"
      type="text"
      name=""
      v-model="distance"
      @keyup.enter="setDistance()"
    />
  </div>
</template>
<script>
import store from "@/store";
import i18n from "@/mixins/mixins";
export default {
  name: "KmInput",
  mixins: [i18n],
  data() {
    return {
      distance: 0,
    };
  },
  async mounted() {
    this.distance = JSON.parse(
      store.getters["reservation/GET_RESERVATION_DISTANCE"]
    );
    document.querySelector("input").addEventListener("keypress", function(evt) {
      if (evt.which < 48 || evt.which > 57) {
        evt.preventDefault();
      }
    });
  },

  methods: {
    setDistance() {
      console.log("send");
      store.dispatch("reservation/SET_DRIVEDISTANCE", this.distance);
    },
  },
};
</script>

